var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/queries/get-claims.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_CLAIMS_MESSAGE_TYPE = "get_claims";
var getClaims = (_0, ..._1) => __async(void 0, [_0, ..._1], function* (userId, limit = 3, order = { type: "last_updated", asc: false }) {
  const info = {
    user_id: userId,
    limit,
    order
  };
  const params = {
    message_type: GET_CLAIMS_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch.fetch(params);
});

// src/queries/get-employer-benefit-categories.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var GET_EMPLOYER_BENEFIT_CATEGORIES_MESSAGE_TYPE = "get_employer_benefit_categories";
var getEmployerBenefitCategories = (userId, benefitId, asOfDate, query, version = 1) => {
  const info = {
    user_id: userId,
    as_of_date: asOfDate,
    query,
    version,
    benefit_id: benefitId
  };
  return SocketAsFetch2.fetch({
    message_type: GET_EMPLOYER_BENEFIT_CATEGORIES_MESSAGE_TYPE,
    info
  });
};

// src/queries/get-faq-links.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var GET_FAQ_LINKS_MESSAGE_TYPE = "get_faq_links";
var getFaqLinks = (benefitProductType, userId) => __async(void 0, null, function* () {
  const info = {
    user_id: userId,
    benefit_product_type: benefitProductType
  };
  const params = {
    message_type: GET_FAQ_LINKS_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch3.fetch(params);
});

// src/queries/get-user-benefit-categories.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var GET_USER_BENEFIT_CATEGORIES_MESSAGE_TYPE = "get_user_benefit_categories";
var getUserBenefitCategories = (userId, benefitId, asOfDate, query, version = 1) => {
  const info = {
    user_id: userId,
    as_of_date: asOfDate,
    query,
    version,
    user_benefit_id: benefitId
  };
  return SocketAsFetch4.fetch({
    message_type: GET_USER_BENEFIT_CATEGORIES_MESSAGE_TYPE,
    info
  });
};

// src/queries/get-user-benefit-live-balances.ts
import { SocketAsFetch as SocketAsFetch5 } from "@leagueplatform/socket-as-fetch";
var GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE = "get_user_benefit_live_balances";
var getUserBenefitLiveBalances = (userId, benefitId, dependentId, version = 1) => __async(void 0, null, function* () {
  const params = {
    message_type: GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE,
    info: {
      user_benefit_id: benefitId,
      user_id: userId,
      dependent_id: dependentId,
      version
    }
  };
  return SocketAsFetch5.fetch(params);
});

// src/queries/get-user-config.ts
import { SocketAsFetch as SocketAsFetch6 } from "@leagueplatform/socket-as-fetch";
var GET_USER_CONFIG_MESSAGE_TYPE = "get_user_config";
var getUserConfig = (userId) => __async(void 0, null, function* () {
  const info = {
    user_id: userId
  };
  const params = {
    message_type: GET_USER_CONFIG_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch6.fetch(params);
});

// src/queries/get-wallet-dependent-cards.ts
import { SocketAsFetch as SocketAsFetch7 } from "@leagueplatform/socket-as-fetch";
var GET_WALLET_DEPENDENT_CARDS_MESSAGE_TYPE = "get_wallet_dependent_cards";
var getWalletDependentCards = (userId) => __async(void 0, null, function* () {
  const info = {
    user_id: userId
  };
  const params = {
    message_type: GET_WALLET_DEPENDENT_CARDS_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch7.fetch(params);
});

// src/queries/get-wallet-item-id.ts
import { SocketAsFetch as SocketAsFetch8 } from "@leagueplatform/socket-as-fetch";
var GET_WALLET_ITEM_ID_MESSAGE_TYPE = "get_wallet_item_id";
var getWalletItemId = (userId, deepLink) => __async(void 0, null, function* () {
  const info = {
    user_id: userId,
    deeplink: deepLink
  };
  const params = {
    message_type: GET_WALLET_ITEM_ID_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch8.fetch(params);
});

// src/queries/get-wallet-items-sectioned.ts
import { SocketAsFetch as SocketAsFetch9 } from "@leagueplatform/socket-as-fetch";
var GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE = "get_wallet_items_sectioned";
var getWalletItemsSectioned = (userId) => __async(void 0, null, function* () {
  const info = {
    id: "wallet_item_navigation_sections",
    user_id: userId
  };
  const params = {
    message_type: GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch9.fetch(params);
});

// src/queries/get-wallet.ts
import { SocketAsFetch as SocketAsFetch10 } from "@leagueplatform/socket-as-fetch";
var GET_WALLET_MESSAGE_TYPE = "get_wallet";
var getWallet = (userId) => __async(void 0, null, function* () {
  const info = {
    user_id: userId,
    suppress_card_actions_and_templates: true,
    options: {
      context: "web"
    }
  };
  const params = {
    message_type: GET_WALLET_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch10.fetch(params);
});

// src/queries/get-wallet-benefit-card.ts
import { SocketAsFetch as SocketAsFetch11 } from "@leagueplatform/socket-as-fetch";

// src/types/card-action.types.ts
var TAB_IDS = /* @__PURE__ */ ((TAB_IDS2) => {
  TAB_IDS2["OVERVIEW"] = "overview";
  TAB_IDS2["OVERVIEW_FRENCH"] = "apercu";
  TAB_IDS2["COVERAGE"] = "coverage";
  TAB_IDS2["DEPENDENT_INFO"] = "dependent-info";
  TAB_IDS2["DEPENDENTS"] = "dependents";
  TAB_IDS2["TRANSACTIONS"] = "purchases";
  TAB_IDS2["LEAGUE_CREDIT"] = "add";
  TAB_IDS2["CARD_INFO"] = "card-info";
  TAB_IDS2["USAGE"] = "usage";
  return TAB_IDS2;
})(TAB_IDS || {});
var ACTION_TYPES = {
  CONTENT: "content",
  OPEN_URL: "open-url"
};
var CONTENT = "content";
var OPEN_URL = "open-url";
var ACTION_IDS = /* @__PURE__ */ ((ACTION_IDS2) => {
  ACTION_IDS2["CARD_INFO"] = "card-info";
  return ACTION_IDS2;
})(ACTION_IDS || {});
var PILL_STATUS = /* @__PURE__ */ ((PILL_STATUS2) => {
  PILL_STATUS2["ACTIVE"] = "active";
  PILL_STATUS2["PENDING"] = "pending";
  PILL_STATUS2["PAST"] = "past";
  return PILL_STATUS2;
})(PILL_STATUS || {});
var CARD_STATUS = /* @__PURE__ */ ((CARD_STATUS2) => {
  CARD_STATUS2["CREATED"] = "created";
  CARD_STATUS2["READY"] = "ready";
  CARD_STATUS2["IN_WAITING_PERIOD"] = "in_waiting_period";
  CARD_STATUS2["INACTIVE"] = "inactive";
  CARD_STATUS2["INACTIVE_GRACE_PERIOD"] = "inactive_grace_period";
  CARD_STATUS2["ACTIVE"] = "active";
  CARD_STATUS2["ALLOCATED"] = "allocated";
  CARD_STATUS2["OPTED_OUT"] = "opted_out";
  return CARD_STATUS2;
})(CARD_STATUS || {});

// src/queries/get-wallet-benefit-card.ts
function getLeagueCreditBenefit(data) {
  const leagueCreditBenefit = __spreadProps(__spreadValues({}, data), {
    id: "league-credit",
    product_type: "promo_code",
    type: "personal_store_credit_balance",
    status: "active" /* ACTIVE */
  });
  const {
    content_actions: contentActions = [],
    primary_action: primaryAction
  } = data;
  let tempContentActions = [...contentActions];
  if (primaryAction) {
    tempContentActions = [primaryAction, ...tempContentActions];
  }
  const leagueCreditContentActions = tempContentActions.map(
    (action) => __spreadProps(__spreadValues({}, action), {
      type: "content",
      // League Credit always has the same two tabs with hardcoded URLs, so we can use them to figure out the system_type
      system_type: action.url === "/member/wallet/promo_code/purchases" ? "transaction_history" : "league_credit"
    })
  ) || [];
  return __spreadProps(__spreadValues({}, leagueCreditBenefit), {
    content_actions: leagueCreditContentActions,
    primary_action: void 0
  });
}
function getWalletBenefitCard(userId, benefitId, dependentId) {
  return __async(this, null, function* () {
    if (!benefitId) {
      throw new Error(`Benefit ID is missing`);
    }
    const message_type = GET_WALLET_MESSAGE_TYPE;
    const isLeagueCredit = benefitId === "league-credit";
    const walletItemId = isLeagueCredit ? "personal_store_credit_balance" : benefitId;
    const info = {
      user_id: userId,
      wallet_item_id: walletItemId,
      suppress_card_actions_and_templates: false,
      version: 6,
      dependent_id: dependentId,
      options: {
        context: "web"
      }
    };
    const data = yield SocketAsFetch11.fetch({
      message_type,
      info
    });
    if (isLeagueCredit && data.personal_store_credit_balance) {
      return getLeagueCreditBenefit(data.personal_store_credit_balance);
    }
    const benefitCard = data.benefit_cards.find(
      (card) => card.id === walletItemId
    );
    if (!benefitCard) {
      throw new Error(`Benefit card ${walletItemId} not found`);
    }
    return benefitCard;
  });
}

// src/queries/get-wallet-benefit-card-v5.ts
import { SocketAsFetch as SocketAsFetch12 } from "@leagueplatform/socket-as-fetch";
function getLeagueCreditBenefit2(data) {
  return __spreadProps(__spreadValues({}, data), {
    actions: data.actions.map(
      (action) => __spreadProps(__spreadValues({}, action), {
        type: "content",
        // League Credit always has the same two tabs with hardcoded URLs, so we can use them to figure out the system_type
        system_type: action.url === "/member/wallet/promo_code/purchases" ? "transaction_history" : "league_credit"
      })
    ),
    id: "league-credit",
    product_type: "promo_code",
    type: "personal_store_credit_balance",
    status: "active" /* ACTIVE */
  });
}
function getWalletBenefitCardV5(userId, benefitId, dependentId) {
  return __async(this, null, function* () {
    if (!benefitId) {
      throw new Error(`Benefit ID is missing`);
    }
    const message_type = GET_WALLET_MESSAGE_TYPE;
    const isLeagueCredit = benefitId === "league-credit";
    const walletItemId = isLeagueCredit ? "personal_store_credit_balance" : benefitId;
    const info = {
      user_id: userId,
      wallet_item_id: walletItemId,
      suppress_card_actions_and_templates: false,
      version: 5,
      dependent_id: dependentId,
      options: {
        context: "web"
      }
    };
    const data = yield SocketAsFetch12.fetch({
      message_type,
      info
    });
    if (isLeagueCredit && data.personal_store_credit_balance) {
      return getLeagueCreditBenefit2(data.personal_store_credit_balance);
    }
    const benefitCard = data.benefit_cards.find(
      (card) => card.id === walletItemId
    );
    if (!benefitCard) {
      throw new Error(`Benefit card ${walletItemId} not found`);
    }
    return benefitCard;
  });
}

// src/queries/submit-benefit-selection.ts
import { SocketAsFetch as SocketAsFetch13 } from "@leagueplatform/socket-as-fetch";
var SUBMIT_BENEFIT_SELECTION_MESSAGE_TYPE = "submit_benefit_selection";
var submitBenefitSelection = (groupId, allocateImmediately, planId) => __async(void 0, null, function* () {
  const params = {
    message_type: SUBMIT_BENEFIT_SELECTION_MESSAGE_TYPE,
    info: {
      group_id: groupId,
      allocate_immediately: !!allocateImmediately,
      plan_id: planId
    }
  };
  return SocketAsFetch13.fetch(params);
});

// src/queries/get-group.ts
import { captureError } from "@leagueplatform/observability";
import { SocketAsFetch as SocketAsFetch14 } from "@leagueplatform/socket-as-fetch";
var GET_GROUP_MESSAGE_TYPE = "get_group";
function getGroup(groupId) {
  if (!groupId) {
    const error = new Error("groupId is required");
    captureError(error);
    throw error;
  }
  return SocketAsFetch14.fetch({
    message_type: GET_GROUP_MESSAGE_TYPE,
    info: {
      group_id: groupId
    }
  });
}

// src/queries/get-provider-services.ts
import { SocketAsFetch as SocketAsFetch15 } from "@leagueplatform/socket-as-fetch";
var GET_PROVIDER_SERVICES_MESSAGE_TYPE = "get_provider_services";
function getProviderServices(userId, benefitId) {
  return SocketAsFetch15.fetch({
    message_type: GET_PROVIDER_SERVICES_MESSAGE_TYPE,
    info: {
      user_id: userId,
      user_benefit_id: benefitId
    }
  });
}

// src/queries/post-id-cards.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
var POST_ID_CARDS_PATH = "/v1/id-cards";
function postIdCards(_0) {
  return __async(this, arguments, function* ({
    data: attributes
  }) {
    const data = {
      type: "id-card",
      attributes
    };
    const response = yield leagueFetch(POST_ID_CARDS_PATH, {
      method: "POST",
      body: JSON.stringify({ data })
    });
    if (!response.ok) {
      throw new Error(`postIdCards error: ${response.status}`);
    }
    return { status: response.status };
  });
}

// src/types/benefit-card.ts
var BENEFIT_CARD_ACTION = /* @__PURE__ */ ((BENEFIT_CARD_ACTION2) => {
  BENEFIT_CARD_ACTION2["CONTENT"] = "content";
  BENEFIT_CARD_ACTION2["OPEN_URL"] = "open-url";
  BENEFIT_CARD_ACTION2["ORDER_CARD"] = "order_card";
  return BENEFIT_CARD_ACTION2;
})(BENEFIT_CARD_ACTION || {});
var OLD_BENEFITS_TYPE = /* @__PURE__ */ ((OLD_BENEFITS_TYPE2) => {
  OLD_BENEFITS_TYPE2["psa"] = "LIFESTYLE_SPENDING_ACCOUNT";
  OLD_BENEFITS_TYPE2["hsa"] = "HEALTH_SPENDING_ACCOUNT";
  OLD_BENEFITS_TYPE2["hra"] = "HEALTH_REIMBURSEMENT_ARRANGEMENT";
  OLD_BENEFITS_TYPE2["healthPlan"] = "HEALTH_INSURANCE";
  OLD_BENEFITS_TYPE2["travel"] = "TRAVEL";
  OLD_BENEFITS_TYPE2["drugs"] = "DRUGS";
  OLD_BENEFITS_TYPE2["promo_code"] = "LEAGUE_CREDIT";
  OLD_BENEFITS_TYPE2["medical"] = "MEDICAL";
  return OLD_BENEFITS_TYPE2;
})(OLD_BENEFITS_TYPE || {});
var CURRENCY = /* @__PURE__ */ ((CURRENCY2) => {
  CURRENCY2[CURRENCY2["CAD"] = 0] = "CAD";
  CURRENCY2[CURRENCY2["USD"] = 1] = "USD";
  CURRENCY2[CURRENCY2["EUR"] = 2] = "EUR";
  return CURRENCY2;
})(CURRENCY || {});

// src/types/benefit-card-action.types.ts
var BE_SYSTEM_TYPES = {
  CoverageOverview: "coverage_overview",
  CoverageCategories: "coverage_categories",
  UsageInstructions: "usage_instructions",
  ViewDependent: "view_dependent",
  TransactionHistory: "transaction_history",
  CardInfo: "card_info",
  VisitUrl: "visit_url",
  CallPhone: "call_phone",
  BeneficiaryForm: "beneficiary_form",
  BenefitDocument: "benefit_document",
  SaveCard: "save_card",
  SubmitClaim: "submit_claim",
  BrowseCategory: "browse_category",
  ContactInfo: "contact_info",
  ViewProviderServices: "view_provider_services",
  // US only
  UnavailableAction: "unavailable_action",
  ModalContent: "modal_content",
  PrintCard: "print_card",
  OrderCard: "order_card"
};
var FE_SYSTEM_TYPES = {
  UsageOverview: "usage_overview",
  LeagueCredit: "league_credit",
  About: "about",
  PlanProgressCoverageOverview: "combined_plan_progress_coverage"
};
var SYSTEM_TYPES = __spreadValues(__spreadValues({}, FE_SYSTEM_TYPES), BE_SYSTEM_TYPES);
var TAB_SYSTEM_TYPES = [
  SYSTEM_TYPES.CoverageOverview,
  SYSTEM_TYPES.CoverageCategories,
  SYSTEM_TYPES.ViewDependent,
  SYSTEM_TYPES.TransactionHistory,
  SYSTEM_TYPES.LeagueCredit,
  SYSTEM_TYPES.ViewProviderServices
];

// src/types/dependents.ts
var RELATIONSHIP_TYPE = /* @__PURE__ */ ((RELATIONSHIP_TYPE2) => {
  RELATIONSHIP_TYPE2["spouse"] = "spouse";
  RELATIONSHIP_TYPE2["common_law"] = "common_law";
  RELATIONSHIP_TYPE2["child"] = "child";
  RELATIONSHIP_TYPE2["parent"] = "parent";
  RELATIONSHIP_TYPE2["grandparent"] = "grandparent";
  RELATIONSHIP_TYPE2["grandchild"] = "grandchild";
  RELATIONSHIP_TYPE2["uncle_aunt"] = "uncle_aunt";
  RELATIONSHIP_TYPE2["nephew_niece"] = "nephew_niece";
  RELATIONSHIP_TYPE2["sibling"] = "sibling";
  RELATIONSHIP_TYPE2["other"] = "other";
  RELATIONSHIP_TYPE2["domestic_partnership"] = "domestic_partnership";
  RELATIONSHIP_TYPE2["ineligible_child"] = "ineligible_child";
  return RELATIONSHIP_TYPE2;
})(RELATIONSHIP_TYPE || {});

// src/types/user-wallet.type.ts
var SELECTION_STATUS = /* @__PURE__ */ ((SELECTION_STATUS2) => {
  SELECTION_STATUS2["NOT_STARTED"] = "not_started";
  SELECTION_STATUS2["STARTED"] = "started";
  SELECTION_STATUS2["COMPLETED"] = "completed";
  return SELECTION_STATUS2;
})(SELECTION_STATUS || {});

// src/types/wallet-item-navigation-section.types.ts
var NAVIGATION_TYPE = /* @__PURE__ */ ((NAVIGATION_TYPE2) => {
  NAVIGATION_TYPE2["OTHER"] = "other";
  NAVIGATION_TYPE2["BENEFIT"] = "benefit";
  NAVIGATION_TYPE2["BENEFITS"] = "benefits";
  return NAVIGATION_TYPE2;
})(NAVIGATION_TYPE || {});

// src/__mocks__/get-provider-services.mock.ts
var definitionMock = {
  title: "",
  description: "<h2>Copay</h2><p>The set amount you pay for certain covered services.</p><h2>Coinsurance</h2><p>The percentage that you may owe for certain covered services or drug costs after reaching your deductible. For example, if your plan pays 80%, you pay 20% coinsurance.</p>"
};
var getProviderServicesMock = {
  metadata: {
    title: "Provider Services",
    description: "Your plan has 2 levels of in-network coverage, plus out-of-network coverage. You can use any level of coverage at anytime within the same plan year.",
    icon: "https://via.placeholder.com/20x20"
  },
  provider_services: {
    in_network: [
      {
        service_name: "Primary Care Visit",
        providers: [
          {
            title: "Enhanced provider",
            copay: {
              M: 6e3,
              F: 60,
              C: "USD"
            },
            coinsurance: 40,
            description: "You pay $60 USD for you visit, 40% coinsurance.",
            definition: definitionMock
          },
          {
            title: "Standard provider",
            copay: {
              M: 8e3,
              F: 80,
              C: "USD"
            },
            coinsurance: 30,
            description: "You pay $80 USD for you visit, 30% coinsurance.",
            definition: definitionMock
          }
        ]
      },
      {
        service_name: "Specialist Visit",
        providers: [
          {
            title: "Enhanced provider",
            copay: {
              M: 6e3,
              F: 60,
              C: "USD"
            },
            coinsurance: 40,
            description: "You pay $60 USD for you visit, 40% coinsurance."
          },
          {
            title: "Standard provider",
            copay: {
              M: 8e3,
              F: 80,
              C: "USD"
            },
            coinsurance: 30,
            description: "You pay $80 USD for you visit, 30% coinsurance."
          }
        ]
      }
    ],
    out_of_network: [
      {
        service_name: "Primary Care Visit",
        providers: [
          {
            title: "Enhanced provider",
            copay: {
              M: 8e3,
              F: 80,
              C: "USD"
            },
            coinsurance: 40,
            description: "You pay $60 USD for you visit, 40% coinsurance."
          },
          {
            title: "Standard provider",
            copay: {
              M: 1e4,
              F: 100,
              C: "USD"
            },
            coinsurance: 20,
            description: "You pay $100 USD for you visit, 20% coinsurance."
          }
        ]
      },
      {
        service_name: "Specialist Visit",
        providers: [
          {
            title: "Enhanced provider",
            copay: {
              M: 8e3,
              F: 80,
              C: "USD"
            },
            coinsurance: 40,
            description: "You pay $60 USD for you visit, 40% coinsurance."
          },
          {
            title: "Standard provider",
            copay: {
              M: 1e4,
              F: 100,
              C: "USD"
            },
            coinsurance: 20,
            description: "You pay $100 USD for you visit, 20% coinsurance."
          }
        ]
      }
    ]
  }
};

// src/__mocks__/get-user-benefit-live-balances.mock.ts
var familyDeductibleBalance = {
  title: "Deductible",
  balance_type: "deductible",
  category: "family",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var familyOutOfPocketBalance = {
  title: "Out-of-Pocket Maximum",
  balance_type: "out_of_pocket_max",
  category: "family",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var individualDeductibleBalance = {
  title: "Deductible",
  balance_type: "deductible",
  category: "individual",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var individualOutOfPocketBalance = {
  title: "Out-of-Pocket Maximum",
  balance_type: "out_of_pocket_max",
  category: "individual",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var deductibleDefinitionMock = {
  balance_type: "deductible",
  title: "Deductible",
  description: "A <strong>deductible</strong> is the amount of money you must pay out-of-pocket (with your own money) in a plan year before your insurance coverage starts. Once you meet the deductible, your insurance plan will offer coverage in the form of cost sharing. The deductible applies to all or most items and services covered by your plan."
};
var outOfPocketMock = {
  balance_type: "out_of_pocket_max",
  title: "Out-of-Pocket Maximum",
  description: "An <strong>out-of-pocket (OOP) maximum</strong> is the most money you can pay during your plan year. Once you meet the maximum, your plan will cover a percentage of future costs for the rest of the plan year."
};
var definitionsMock = [deductibleDefinitionMock, outOfPocketMock];
var enhancedDeductibleProviderMock = {
  provider: "Enhanced Provider",
  provider_id: "enhanced_provider",
  balances: [familyDeductibleBalance, individualDeductibleBalance]
};
var enhancedOutOfPocketMock = __spreadProps(__spreadValues({}, enhancedDeductibleProviderMock), {
  balances: [familyOutOfPocketBalance, individualOutOfPocketBalance]
});
var standardProviderMock = {
  provider: "",
  provider_id: "",
  balances: [
    familyDeductibleBalance,
    individualDeductibleBalance,
    familyOutOfPocketBalance,
    individualOutOfPocketBalance
  ]
};
var getUserBenefitLiveBalancesWithTiersV2Mock = {
  last_updated: "2022-07-01T01:00:00Z",
  carrier_name: "Cigna",
  accumulation_period: {
    start: "2022-01-01T01:00:00Z",
    end: "2022-12-31T01:00:00Z"
  },
  definitions: definitionsMock,
  in_network: [enhancedDeductibleProviderMock, standardProviderMock],
  out_of_network: [enhancedDeductibleProviderMock, standardProviderMock]
};
var getUserBenefitLiveBalancesWithoutTiersV2Mock = {
  last_updated: "2022-07-01T01:00:00Z",
  carrier_name: "Cigna",
  accumulation_period: {
    start: "2022-01-01T01:00:00Z",
    end: "2022-12-31T01:00:00Z"
  },
  definitions: definitionsMock,
  in_network: [standardProviderMock],
  out_of_network: [standardProviderMock]
};
var enhancedBalanceV2 = {
  title: "Enhanced Level",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var standardBalanceV2 = {
  title: "Standard Level",
  paid_amount: {
    M: 75e3,
    F: 750,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 250,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 1e3,
    C: "USD"
  }
};
var outOfNetworkStandardBalanceV2 = {
  title: "Standard Level",
  paid_amount: {
    M: 75e3,
    F: 950,
    C: "USD"
  },
  remaining_amount: {
    M: 25e3,
    F: 750,
    C: "USD"
  },
  limit: {
    M: 1e5,
    F: 6e3,
    C: "USD"
  }
};
var deductibleDefinitionMockV2 = {
  title: "Deductible",
  description: "A <strong>deductible</strong> is the amount of money you must pay out-of-pocket (with your own money) in a plan year before your insurance coverage starts. Once you meet the deductible, your insurance plan will offer coverage in the form of cost sharing. The deductible applies to all or most items and services covered by your plan."
};
var outOfPocketDefinitionMockV2 = {
  title: "Out-of-Pocket Maximum",
  description: "An <strong>out-of-pocket (OOP) maximum</strong> is the most money you can pay during your plan year. Once you meet the maximum, your plan will cover a percentage of future costs for the rest of the plan year."
};
var singleTierCategoryMockV2 = {
  type: "family",
  title: "Family",
  definition: deductibleDefinitionMockV2,
  balances: [standardBalanceV2]
};
var multiTierFamilyCategoryMockV2 = {
  type: "family",
  title: "Family",
  definition: outOfPocketDefinitionMockV2,
  balances: [standardBalanceV2, enhancedBalanceV2]
};
var multiTierIndividualCategoryMockV2 = {
  type: "individual",
  title: "Individual",
  definition: outOfPocketDefinitionMockV2,
  balances: [standardBalanceV2, enhancedBalanceV2]
};
var outOfNetworkMultiTierCategoryMockV2 = {
  type: "family",
  title: "Family",
  definition: outOfPocketDefinitionMockV2,
  balances: [outOfNetworkStandardBalanceV2, enhancedBalanceV2]
};
var outOfPocketSingleTierProviderMockV2 = {
  title: "Out of Pocket",
  description: "An <strong>out-of-pocket (OOP) maximum</strong> is the most money you can pay during your plan year. Once you meet the maximum, your plan will cover a percentage of future costs for the rest of the plan year.",
  categories: [singleTierCategoryMockV2]
};
var deductibleSingleTierProviderMockV2 = {
  title: "Deductible",
  description: "A <strong>deductible</strong> is the amount of money you must pay out-of-pocket (with your own money) in a plan year before your insurance coverage starts. Once you meet the deductible, your insurance plan will offer coverage in the form of cost sharing. The deductible applies to all or most items and services covered by your plan.",
  categories: [singleTierCategoryMockV2]
};
var outOfPocketMultiTierProviderMockV2 = {
  title: "Out of Pocket",
  description: "An <strong>out-of-pocket (OOP) maximum</strong> is the most money you can pay during your plan year. Once you meet the maximum, your plan will cover a percentage of future costs for the rest of the plan year.",
  categories: [
    multiTierFamilyCategoryMockV2,
    multiTierIndividualCategoryMockV2
  ]
};
var deductibleMultiTierProviderMockV2 = {
  title: "Deductible",
  description: "A <strong>deductible</strong> is the amount of money you must pay out-of-pocket (with your own money) in a plan year before your insurance coverage starts. Once you meet the deductible, your insurance plan will offer coverage in the form of cost sharing. The deductible applies to all or most items and services covered by your plan.",
  categories: [
    multiTierFamilyCategoryMockV2,
    multiTierIndividualCategoryMockV2
  ]
};
var outOfNetworkDeductibleMultiTierProviderMockV2 = {
  title: "Deductible",
  description: "A <strong>deductible</strong> is the amount of money you must pay out-of-pocket (with your own money) in a plan year before your insurance coverage starts. Once you meet the deductible, your insurance plan will offer coverage in the form of cost sharing. The deductible applies to all or most items and services covered by your plan.",
  categories: [outOfNetworkMultiTierCategoryMockV2]
};
var getUserBenefitLiveBalancesWithTiersMockV2 = {
  last_updated: "2022-07-01T01:00:00Z",
  carrier_name: "Cigna",
  accumulation_period: {
    start: "2022-01-01T01:00:00Z",
    end: "2022-12-31T01:00:00Z"
  },
  in_network: [
    outOfPocketMultiTierProviderMockV2,
    deductibleMultiTierProviderMockV2
  ],
  out_of_network: [
    outOfPocketMultiTierProviderMockV2,
    outOfNetworkDeductibleMultiTierProviderMockV2
  ]
};
var getUserBenefitLiveBalancesWithoutTiersMockV2 = {
  last_updated: "2022-07-01T01:00:00Z",
  carrier_name: "Cigna",
  accumulation_period: {
    start: "2022-01-01T01:00:00Z",
    end: "2022-12-31T01:00:00Z"
  },
  in_network: [
    outOfPocketSingleTierProviderMockV2,
    deductibleSingleTierProviderMockV2
  ],
  out_of_network: [
    outOfPocketSingleTierProviderMockV2,
    deductibleSingleTierProviderMockV2
  ]
};

// src/__mocks__/get-wallet-items-sectioned-mock.ts
var setMockItemStatus = (item, itemStatus) => __spreadProps(__spreadValues({}, item), { status: itemStatus });
var mockHealthSpendingAccountItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "2e76a9572fc058160b018a543525d92b",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "hsa",
  name: {
    text: "Health Spending Account",
    language: "en-CA"
  },
  vendor_id: "league",
  vendor_name: {
    text: "League",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockVisionItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_vision",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "vision",
  name: {
    text: "Vision",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockParamedicalServicesItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_paramedical",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "paramedical",
  name: {
    text: "Paramedical Services",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockMedicalServicesSuppliesItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_medical-services-and-supplies",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "medical_services_and_supplies",
  name: {
    text: "Medical Services & Supplies",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockMentalHealthItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_mental-health",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "mental_health",
  name: {
    text: "Mental Health",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockDrugItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "34013d8bbb9c9b6b3cf3cc6c0ef47e26",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "drug",
  name: {
    text: "Drug",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockAccreditationItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "5e3b54b58ff40e0408f642314f369bad",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "internal_program",
  name: {
    text: "Accreditation",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockAdoptionAssistanceItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6af4316baee4c67d6d291eaa749322fc",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "internal_program",
  name: {
    text: "Adoption/Surrogacy Assistance",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockDentalItem = {
  status: "created" /* CREATED */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "d4d372b3368cb7413366250b63e9225a",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "dental",
  name: {
    text: "Dental",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockLeagueItem = {
  status: "active" /* ACTIVE */,
  id: "personal_store_credit_balance",
  name: {
    text: "League Credit",
    language: "en-CA"
  },
  vendor_id: "league",
  vendor_name: {
    text: "League",
    language: "en-CA"
  },
  type: "other",
  is_new_benefit: false,
  wallet_item_id: "personal_store_credit_balance"
};
var mockLifestyleSpendingAccountItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "b499f4fe176692d61d982030a3165a45",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "lsa",
  name: {
    text: "Lifestyle Spending Account",
    language: "en-CA"
  },
  vendor_id: "league",
  vendor_name: {
    text: "League",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockRRSPItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "fb33ef25793caad4de45666309cfaed2",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "rrsp",
  name: {
    text: "RRSP",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockTFSAItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "9915b6c61a8c7506fd60855cc8abaa0d",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "tfsa",
  name: {
    text: "TFSA",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockPensionItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "cc2e065bddc264c33988e63270be355e",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "pension",
  name: {
    text: "Pension",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockEmployeeAssistanceProgram = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "73f414db320f0b7b67cf81b8b80cf763",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "eap",
  name: {
    text: "Employee Assistance Program",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockParentalLeaveItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "be1e6814f63ba441eddbecdd3363398a",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "internal_program",
  name: {
    text: "Parental Leave",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockSabbaticalLeaveItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "4744165df35e2e731b1f33dff48ca2f6",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "internal_program",
  name: {
    text: "Sabbatical Leave",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockEmergencyTravelAssistanceItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_travel",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "travel",
  name: {
    text: "Emergency Travel Assistance",
    language: "en-CA"
  },
  vendor_id: "sunlife",
  vendor_name: {
    text: "Sun Life",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockOptionalLifeItem = {
  status: "active" /* ACTIVE */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "d5f562e42a69e181addf46c681cb6010",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "optional_life",
  name: {
    text: "Optional Life",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockBusinessTravelItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "e562e18ec241c7e24fc53f69cbc5dcb6",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "travel",
  name: {
    text: "Business Travel",
    language: "en-CA"
  },
  vendor_id: "sutton",
  vendor_name: {
    text: "Sutton Special Risk",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockWorkLifeFlexibilityItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "29ed0d5e46fc75de6e9ae41698df0e83",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "internal_program",
  name: {
    text: "Work Life Flexibility",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockMISPShortTermDisabilityItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "3143624ceaf01d079c7b1486161d75a4",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "std",
  name: {
    text: "MISP Short-Term Disability",
    language: "en-CA"
  },
  vendor_id: "kpmg",
  vendor_name: {
    text: "KPMG",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockLongTermDisabilityItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "25cfbcf96847392ade2affc9da812150",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "ltd",
  name: {
    text: "Long-Term Disability",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockOptionalAccidentItem = {
  status: "ready" /* READY */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "dff2056d03d8779aef54da93ec1d833a",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "optional_accident",
  name: {
    text: "Optional Accident",
    language: "en-CA"
  },
  vendor_id: "sutton",
  vendor_name: {
    text: "Sutton Special Risk",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockLifeItem = {
  status: "created" /* CREATED */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "db57a2c7cc25638624e749a2da8bef6c",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "life",
  name: {
    text: "Life",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockSpouseOptionalLifeItem = {
  status: "created" /* CREATED */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "b3b5a9bfe35d8ab44dbd999c54270e0b",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "spouse_optional_life",
  name: {
    text: "Spouse Optional Life",
    language: "en-CA"
  },
  vendor_id: "manulife",
  vendor_name: {
    text: "Manulife",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var mockSpouseAccidentItem = {
  status: "created" /* CREATED */,
  group_id: "c6965889c1924abee5a8a7aec49de92c",
  benefit_id: "1b2882ee684a33f691c66a2063c2b741",
  id: "",
  wallet_item_id: "",
  benefit_product_type: "spouse_accident",
  name: {
    text: "Spouse Accident",
    language: "en-CA"
  },
  vendor_id: "sutton",
  vendor_name: {
    text: "Sutton Special Risk",
    language: "en-CA"
  },
  type: "benefit",
  is_new_benefit: false,
  benefit_source: "benefit-source"
};
var walletItemNavigationSectionsMock = {
  id: "wallet_item_navigation_sections",
  items_sectioned: [
    {
      section_id: "benefits",
      name: {
        text: "Benefits",
        language: "en-CA"
      },
      sections: [
        {
          section_id: "health-and-wellness",
          name: {
            text: "Mental Health & Wellbeing",
            language: "en-CA"
          },
          wallet_items: [
            mockHealthSpendingAccountItem,
            mockVisionItem,
            mockParamedicalServicesItem,
            mockMedicalServicesSuppliesItem,
            mockMentalHealthItem,
            mockDrugItem,
            mockAccreditationItem,
            mockAdoptionAssistanceItem,
            setMockItemStatus(mockDentalItem, "created" /* CREATED */),
            setMockItemStatus(
              mockMedicalServicesSuppliesItem,
              "inactive_grace_period" /* INACTIVE_GRACE_PERIOD */
            ),
            setMockItemStatus(
              mockMentalHealthItem,
              "inactive_grace_period" /* INACTIVE_GRACE_PERIOD */
            )
          ]
        },
        {
          section_id: "financial",
          name: {
            text: "Financial",
            language: "en-CA"
          },
          wallet_items: [
            mockLifestyleSpendingAccountItem,
            setMockItemStatus(mockRRSPItem, "ready" /* READY */),
            setMockItemStatus(mockTFSAItem, "ready" /* READY */),
            setMockItemStatus(mockPensionItem, "ready" /* READY */)
          ]
        },
        {
          section_id: "work-and-life",
          name: {
            text: "Work & Life",
            language: "en-CA"
          },
          wallet_items: [
            setMockItemStatus(
              mockEmployeeAssistanceProgram,
              "ready" /* READY */
            ),
            setMockItemStatus(mockParentalLeaveItem, "ready" /* READY */),
            setMockItemStatus(mockSabbaticalLeaveItem, "ready" /* READY */),
            setMockItemStatus(mockWorkLifeFlexibilityItem, "ready" /* READY */)
          ]
        },
        {
          section_id: "insurance-and-protection",
          name: {
            text: "Insurance & Protection",
            language: "en-CA"
          },
          wallet_items: [
            mockEmergencyTravelAssistanceItem,
            mockOptionalLifeItem,
            setMockItemStatus(mockBusinessTravelItem, "ready" /* READY */),
            setMockItemStatus(
              mockMISPShortTermDisabilityItem,
              "ready" /* READY */
            ),
            setMockItemStatus(mockLongTermDisabilityItem, "ready" /* READY */),
            setMockItemStatus(mockOptionalAccidentItem, "ready" /* READY */),
            setMockItemStatus(mockLifeItem, "created" /* CREATED */),
            setMockItemStatus(
              mockSpouseOptionalLifeItem,
              "created" /* CREATED */
            ),
            setMockItemStatus(mockSpouseAccidentItem, "created" /* CREATED */),
            setMockItemStatus(
              mockEmergencyTravelAssistanceItem,
              "inactive_grace_period" /* INACTIVE_GRACE_PERIOD */
            )
          ]
        }
      ]
    },
    {
      section_id: "other",
      name: {
        text: "Other",
        language: "en-CA"
      },
      sections: [],
      wallet_items: [
        {
          status: "active" /* ACTIVE */,
          id: "personal_store_credit_balance",
          name: {
            text: "League Credit",
            language: "en-CA"
          },
          vendor_id: "league",
          vendor_name: {
            text: "League",
            language: "en-CA"
          },
          type: "other",
          is_new_benefit: false,
          wallet_item_id: "personal_store_credit_balance"
        }
      ]
    }
  ]
};
var walletItemNavigationSectionsSingleStatusMock = {
  id: "wallet_item_navigation_sections",
  items_sectioned: [
    {
      section_id: "benefits",
      name: {
        text: "Benefits",
        language: "en-CA"
      },
      wallet_items: void 0,
      sections: [
        {
          section_id: "health-and-wellness",
          name: {
            text: "Health & Well-Being",
            language: "en-CA"
          },
          wallet_items: [mockHealthSpendingAccountItem, mockVisionItem]
        },
        {
          section_id: "financial",
          name: {
            text: "Financial",
            language: "en-CA"
          },
          wallet_items: [mockLifestyleSpendingAccountItem]
        }
      ]
    }
  ]
};
export {
  ACTION_IDS,
  ACTION_TYPES,
  BENEFIT_CARD_ACTION,
  CARD_STATUS,
  CONTENT,
  CURRENCY,
  GET_CLAIMS_MESSAGE_TYPE,
  GET_EMPLOYER_BENEFIT_CATEGORIES_MESSAGE_TYPE,
  GET_FAQ_LINKS_MESSAGE_TYPE,
  GET_GROUP_MESSAGE_TYPE,
  GET_PROVIDER_SERVICES_MESSAGE_TYPE,
  GET_USER_BENEFIT_CATEGORIES_MESSAGE_TYPE,
  GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE,
  GET_USER_CONFIG_MESSAGE_TYPE,
  GET_WALLET_DEPENDENT_CARDS_MESSAGE_TYPE,
  GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE,
  GET_WALLET_ITEM_ID_MESSAGE_TYPE,
  GET_WALLET_MESSAGE_TYPE,
  NAVIGATION_TYPE,
  OLD_BENEFITS_TYPE,
  OPEN_URL,
  PILL_STATUS,
  POST_ID_CARDS_PATH,
  RELATIONSHIP_TYPE,
  SELECTION_STATUS,
  SUBMIT_BENEFIT_SELECTION_MESSAGE_TYPE,
  SYSTEM_TYPES,
  TAB_IDS,
  TAB_SYSTEM_TYPES,
  definitionsMock,
  enhancedDeductibleProviderMock,
  enhancedOutOfPocketMock,
  getClaims,
  getEmployerBenefitCategories,
  getFaqLinks,
  getGroup,
  getProviderServices,
  getProviderServicesMock,
  getUserBenefitCategories,
  getUserBenefitLiveBalances,
  getUserBenefitLiveBalancesWithTiersMockV2,
  getUserBenefitLiveBalancesWithTiersV2Mock,
  getUserBenefitLiveBalancesWithoutTiersMockV2,
  getUserBenefitLiveBalancesWithoutTiersV2Mock,
  getUserConfig,
  getWallet,
  getWalletBenefitCard,
  getWalletBenefitCardV5,
  getWalletDependentCards,
  getWalletItemId,
  getWalletItemsSectioned,
  mockAccreditationItem,
  mockAdoptionAssistanceItem,
  mockBusinessTravelItem,
  mockDentalItem,
  mockDrugItem,
  mockEmergencyTravelAssistanceItem,
  mockEmployeeAssistanceProgram,
  mockHealthSpendingAccountItem,
  mockLeagueItem,
  mockLifeItem,
  mockLifestyleSpendingAccountItem,
  mockLongTermDisabilityItem,
  mockMISPShortTermDisabilityItem,
  mockMedicalServicesSuppliesItem,
  mockMentalHealthItem,
  mockOptionalAccidentItem,
  mockOptionalLifeItem,
  mockParamedicalServicesItem,
  mockParentalLeaveItem,
  mockPensionItem,
  mockRRSPItem,
  mockSabbaticalLeaveItem,
  mockSpouseAccidentItem,
  mockSpouseOptionalLifeItem,
  mockTFSAItem,
  mockVisionItem,
  mockWorkLifeFlexibilityItem,
  postIdCards,
  standardProviderMock,
  submitBenefitSelection,
  walletItemNavigationSectionsMock,
  walletItemNavigationSectionsSingleStatusMock
};
//# sourceMappingURL=index.js.map